import React, { useState, useEffect, useRef } from 'react'
import Navbar from '../../../ReusableBlocks/Navbar'
import Modal from 'react-bootstrap/Modal';
import Swal from 'sweetalert2';
import { Link, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';
import { fetchProfile } from '../../../Redux/Dashboard/External/USER_PROFILE/userProfileAction';
import { fetchLearningHub } from '../../../Redux/Dashboard/External/LearningHub/LearningHubGetDataAction';
import { changePassword, resetOnSuccessChangePassword } from '../../../Redux/Dashboard/External/USER_PROFILE/ChangePasswordAction';
import { updateTenantDetails, addTenantDetails, resetOnSuccess } from '../../../Redux/Dashboard/External/USER_PROFILE/UpdateTenantAction';
import { onboardTenant, resetOnboardTenantSuccess } from '../../../Redux/Dashboard/External/USER_PROFILE/OnboardTenantAction';
import LoadingScreen from '../../../ReusableBlocks/LoadingScreen';
import TenantUrlInput, { BHOM_TEMPLATE, ITSM_TEMPLATE } from '../../../ReusableBlocks/TenantUrlInput';
import CryptoJS from 'crypto-js';
import * as PATH from '../../../CentralisedLink'
import { HELIXOPS_EMAIL_DOMAIN } from '../../../Constants/emailMigration';
import {
  deleteUserTenant,
  deleteUserTenantReset,
} from '../../../Redux/Dashboard/External/USER_PROFILE/DeleteTenantAction';
import { useFeatureFlags } from '../../../FeatureFlags/FeatureFlagsContext';
import { FEATURE_FLAGS } from '../../../FeatureFlags/featureFlagConstants';

const getFirstStringValue = (values) => {
  return values.find((value) => typeof value === 'string' && value.trim()) || '';
};

const getProfileUserEmail = (profileDetails, currentUser) => {
  return getFirstStringValue([
    profileDetails?.email,
    profileDetails?.username,
    profileDetails?.emailAddress,
    profileDetails?.userEmail,
    currentUser?.email,
    currentUser?.username,
    currentUser?.emailAddress,
    currentUser?.userEmail,
    currentUser?.preferred_username,
    currentUser?.upn,
    currentUser?.sub,
  ]);
};


const User_Profile = (props) => {


  const secretKey = 'micro';

  const encryptId = (id) => {
    const ciphertext = CryptoJS.AES.encrypt(id, secretKey).toString();
    return encodeURIComponent(ciphertext);
  };

  const currentUser = useSelector(state => state.auth?.currentUser);
  const deleteTenantState = useSelector((state) => state.DeleteTenant || {});

  const [passwordChange, setPasswordChange] = useState(false);
  const [step, setStep] = useState(1);
  const [oldPasswordEntered, setOldPasswordEntered] = useState(false);
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const [showSubCourses, setShowSubCourses] = useState(false);
  const [screenSize, setScreenSize] = useState('');
  const [showWhatsNew, setShowWhatsNew] = useState(false);
  const [completedTracks, setCompletedTracks] = useState({});
  const [profileData, setProfileData] = useState({});
  // Local flags to trigger onboard only after updateTenantDetails success
  const [pendingOnboard, setPendingOnboard] = useState(false);
  const [onboardPayload, setOnboardPayload] = useState(null);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isFeatureEnabled } = useFeatureFlags();
  const enableEnablement = isFeatureEnabled(FEATURE_FLAGS.EnableEnablement);
  // keep the last attempted onboarding payload for retries
  const lastOnboardPayloadRef = useRef(null);


  const profileState = useSelector((state) => state.profile);
  // Onboard redux state
  const onboardState = useSelector(state => state.OnboardTenant);

  const [tenantData, setTenantData] = useState({
    bhomUrl: '',
    itsmUrl: '',
    key: '',
    secretKey: '',
    username: '',
    password: '',
  });




  const isLoading = useSelector(state => state.tenentDetails?.loading);
  const errorMessage = useSelector(state => state.tenentDetails?.error);
  const updateSuccess = useSelector(state => state.tenentDetails?.updateSuccess);
  // whole slice so we can read any message the reducer provides
  const tenantUpdateState = useSelector(state => state.tenentDetails || {});

  const getStepMessage = (value, fallbackLabel) => {
    if (!value) return '';

    if (typeof value === 'string') {
      return value.trim();
    }

    if (typeof value === 'object') {
      // Backend may return: { "Successfully uploaded IS process package.": "" }
      const keys = Object.keys(value || {}).filter(Boolean);
      if (keys.length > 0) {
        return keys.join(', ');
      }

      // fallback if weird object
      try {
        return JSON.stringify(value);
      } catch {
        return fallbackLabel || '';
      }
    }

    return String(value);
  };

  const getOnboardOutcome = (raw) => {
    const payload = raw || {};

    const importMsg = getStepMessage(
      payload['import-is-package-result'],
      'IS package step finished.'
    );

    const onboardMsg = getStepMessage(
      payload['onboard-tenant-result'],
      'Tenant onboarding step finished.'
    );

    const hasStepResponses = !!(importMsg || onboardMsg);

    const mainMsg =
      (typeof payload.error === 'string' && payload.error.trim()) ||
      (typeof payload.success === 'string' && payload.success.trim()) ||
      (typeof payload.message === 'string' && payload.message.trim()) ||
      '';

    return {
      hasStepResponses,
      mainMsg,
      importMsg,
      onboardMsg,
    };
  };

  const getOnboardDisplay = (raw, mode = 'success') => {
    if (!raw) {
      return {
        summary: mode === 'error' ? 'Onboarding failed' : 'Onboarding completed',
        details: [],
      };
    }

    // plain string = normal pre-step response
    if (typeof raw === 'string') {
      return {
        summary: raw,
        details: [],
      };
    }

    const { mainMsg, importMsg, onboardMsg } = getOnboardOutcome(raw);

    const details = [];

    if (importMsg) {
      details.push({
        label: 'Import IS Package',
        msg: importMsg,
        tone: mode === 'error' ? 'warn' : 'success',
      });
    }

    if (onboardMsg) {
      details.push({
        label: 'Tenant Onboard',
        msg: onboardMsg,
        tone: mode === 'error' ? 'warn' : 'success',
      });
    }

    return {
      summary:
        mainMsg ||
        (mode === 'error'
          ? 'Onboarding incomplete. One or more steps failed.'
          : 'Successfully onboarded tenant.'),
      details,
    };
  };

  const getOnboardErrorMessage = (err) => {
    if (!err) return 'Unknown onboarding error';

    // simple string error = pre-step failure
    if (typeof err === 'string') return err;

    if (typeof err === 'object') {
      const { hasStepResponses, mainMsg, importMsg, onboardMsg } = getOnboardOutcome(err);

      // ✅ If backend has reached IS/CTM stage, show step messages too
      if (hasStepResponses) {
        const parts = [];

        if (mainMsg) parts.push(mainMsg);
        if (importMsg) parts.push(`Import IS Package: ${importMsg}`);
        if (onboardMsg) parts.push(`Tenant Onboard: ${onboardMsg}`);

        return parts.join(' | ');
      }

      // ✅ If backend failed before reaching IS/CTM stage, show normal API error only
      if (mainMsg) return mainMsg;

      try {
        return JSON.stringify(err);
      } catch {
        return 'Onboarding failed';
      }
    }

    return String(err);
  };



  const pickServerMsg = (obj = {}) => {
    const candidates = [
      obj.message,
      obj.success,
      obj.successMessage,
      obj.updateMessage,
      obj.msg,
      // some APIs put it inside a payload/result
      obj.result?.message,
      obj.payload?.message,
    ];
    return candidates.find(v => typeof v === 'string' && v.trim());
  };



  const isLoadingPass = useSelector(state => state.changePassword?.loading);
  const errorMessagePass = useSelector(state => state.changePassword?.error);
  const updateSuccessPass = useSelector(state => state.changePassword?.profilePasswordUpdate);

  const isLoadingPro = useSelector(state => state.profile?.loading);
  const errorMessagePro = useSelector(state => state.profile?.error);
  const updateSuccessPro = useSelector(state => state.profile?.success);


  // State to track if any changes have been made
  const [isChanged, setIsChanged] = useState(false);
  const [badgde, setbadgde] = useState('');
  const [badgeModel, setBadgdeModel] = useState(false)
  const [editMode, setEditMode] = useState(false);


  // Onboard opt-in + modal state
  // Onboard inline state (no modal)
  const [onboardOptIn, setOnboardOptIn] = useState(false);
  // const [hannaPwd, setHannaPwd] = useState('');
  // const [showHannaPwd, setShowHannaPwd] = useState(false);



  const profile = profileState.profile;
  const profileDetails = profile?.['profile-details'];
  const tenantDetailsArr = profileDetails?.["tenant-details"] || [];
  const userEmail = getProfileUserEmail(profileDetails, currentUser);
  const isBmcUser = userEmail?.toLowerCase().trim().endsWith('@bmc.com');

  const handleEmailMigrationClick = () => {
    navigate(PATH.UPDATE_EMAIL_PATH);
  };


  const handleViewBadge = (badge) => {
    setbadgde(badge)
    setBadgdeModel(true);
  };
  const handleCloseViewBadge = () => setBadgdeModel(false);



  const handleShowPay = () => {
    setPasswordChange(true);
    setStep(1);
    setOldPasswordEntered(false);
  };

  const handleClosePay = () => {
    setPasswordChange(false);
    setOldPassword('');
    setNewPassword('');
    setConfirmPassword('');
  };

  const handleShowWhatsNew = () => setShowWhatsNew(true);
  const handleCloseWhatsNew = () => setShowWhatsNew(false);


  // --- Coordinated flow: Save + optional Onboard (single summary popup)
  const FLOW_IDLE = {
    active: false,
    wantOnboard: false,
    save: { status: 'idle', msg: '' }, // 'pending' | 'success' | 'error'
    onboard: {
      status: 'na',                    // 'na' | 'pending' | 'success' | 'error' | 'skipped'
      msg: '',
      details: [],                     // [{ label, msg, tone }]
    },
  };
  const [flow, setFlow] = useState(FLOW_IDLE);




  // Build (or reuse) the last onboarding payload for retries
  const buildOnboardRetryPayload = () => {
    // 1) prefer the last payload you actually used
    if (lastOnboardPayloadRef.current) return lastOnboardPayloadRef.current;

    // 2) otherwise derive from current form fields
    return {
      bhomUrl: tenantData?.bhomUrl || '',
      itsmUrl: tenantData?.itsmUrl || null,
      key: tenantData?.key || '',
      secretKey: tenantData?.secretKey || '',
      // password: hannaPwd?.trim() ? hannaPwd.trim() : null,
      username: (tenantData?.username || "").trim(),
      password: tenantData?.password || "",
      // adminPassword: hannaPwd?.trim() ? hannaPwd.trim() : null,
    };
  };

  // SweetAlert with Retry + Cancel (left-aligned, multi-retry enabled)
  const showRetryableOnboardError = (msg) => {
    Swal.fire({
      icon: 'error',
      title: 'Onboarding failed',
      html: `<p class="swal-msg-center">${yadsEscapeHtml(msg || 'Unknown error')}</p>`,
      showCancelButton: true,
      confirmButtonText: 'Retry',
      cancelButtonText: 'Cancel',
      reverseButtons: true,
      confirmButtonColor: '#05264e',
      customClass: { popup: 'swal-center' },
      didOpen: (el) => {
        // hard-force center even if global styles exist
        const c = el.querySelector('.swal2-html-container');
        if (c) c.style.textAlign = 'center';
      }
    }).then(res => {
      if (!res.isConfirmed) return;

      const retryPayload = buildOnboardRetryPayload();
      // minimal validation
      if (!retryPayload.bhomUrl || !retryPayload.key || !retryPayload.secretKey) {
        Swal.fire({
          icon: 'warning',
          title: 'Missing details',
          text: 'Please complete BHOM URL, Access Key and Secret Key before retrying onboarding.'
        });
        return;
      }

      lastOnboardPayloadRef.current = retryPayload;  // keep for yet another retry
      dispatch(onboardTenant(retryPayload));         // if it fails again, this dialog reappears
    });
  };



  useEffect(() => {
    dispatch(fetchProfile());
    if (enableEnablement) {
      dispatch(fetchLearningHub());
    }
  }, [dispatch, enableEnablement]);

  // Profile Fetching Error 
  useEffect(() => {
    if (errorMessagePro && errorMessage !== 'You have not completed mandatory Tech Central Training, please complete it.') {
      Swal.fire({
        title: 'Error',
        text: errorMessagePro,
        icon: 'error',
        confirmButtonText: 'Retry',
        showCancelButton: true,
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          window.location.reload();
        }
      });
    }
  }, [errorMessagePro]);



  useEffect(() => {
    if (!errorMessage) return;

    if (flow.active && flow.wantOnboard) {
      // Part of coordinated flow → no immediate toast
      setFlow(prev => ({
        ...prev,
        save: { status: 'error', msg: String(errorMessage) },
        onboard: { status: 'skipped', msg: 'Not started due to save failure.' },
      }));
      setPendingOnboard(false);
      setOnboardPayload(null);
      dispatch(resetOnSuccess());
    } else {
      // Standalone behavior
      dispatch(resetOnSuccess());
      Swal.fire({
        title: 'Error',
        text: errorMessage,
        icon: 'error',
        showCancelButton: true,
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      });
    }
  }, [errorMessage, flow.active, flow.wantOnboard, dispatch]);



  useEffect(() => {
    if (!onboardState?.error) return;

    const onboardErrMsg = getOnboardErrorMessage(onboardState.error);
    const display = getOnboardDisplay(onboardState.error, 'error');

    if (flow.active && flow.wantOnboard) {
      setFlow(prev => ({
        ...prev,
        onboard: {
          status: 'error',
          msg: display.summary || onboardErrMsg,
          details: display.details || [],
        },
      }));
    } else {
      showRetryableOnboardError(onboardErrMsg);
    }

    dispatch(resetOnboardTenantSuccess());
  }, [onboardState?.error, flow.active, flow.wantOnboard, dispatch]);



  useEffect(() => {
    if (!onboardState?.success) return;

    const payload = onboardState?.data || onboardState?.payload || {};
    const { hasStepResponses, mainMsg, importMsg, onboardMsg } = getOnboardOutcome(payload);

    const finalMainMsg = mainMsg || 'Successfully onboarded tenant.';

    const lines = [];
    if (importMsg) lines.push({ label: 'Import IS Package', msg: importMsg });
    if (onboardMsg) lines.push({ label: 'Tenant Onboard', msg: onboardMsg });

    if (flow.active && flow.wantOnboard) {
      const display = getOnboardDisplay(payload, 'success');

      setFlow(prev => ({
        ...prev,
        onboard: {
          status: 'success',
          msg: display.summary || finalMainMsg,
          details: display.details || [],
        },
      }));

      dispatch(resetOnboardTenantSuccess());
      return;
    }

    // standalone success popup
    const display = getOnboardDisplay(payload, 'success');

    Swal.fire({
      icon: 'success',
      title: display.summary || finalMainMsg,
      html: display.details?.length
        ? `
      <div class="yads-standalone-steps">
        ${display.details
          .map(
            (x) => `
              <div class="yads-standalone-step">
                <div class="yads-standalone-step__head">
                  <span class="yads-standalone-step__label">${x.label}</span>
                  <span class="yads-standalone-step__chip">Done</span>
                </div>
                <div class="yads-standalone-step__msg">${yadsEscapeHtml(x.msg)}</div>
              </div>
            `
          )
          .join('')}
      </div>
    `
        : '',
      confirmButtonColor: '#05264e',
      didOpen: () => {
        ensureYadsSwalStyles();
      },
    });

    dispatch(resetOnboardTenantSuccess());
  }, [
    onboardState?.success,
    onboardState?.data,
    onboardState?.payload,
    flow.active,
    flow.wantOnboard,
    dispatch,
  ]);



  useEffect(() => {
    if (!updateSuccess) return;

    // prefer backend message, fall back to your old string
    const serverMsg = pickServerMsg(tenantUpdateState) || 'Tenant details updated successfully';


    if (flow.active && flow.wantOnboard) {
      // Part of coordinated flow → mark save complete, then kick onboarding
      setFlow(prev => ({ ...prev, save: { status: 'success', msg: serverMsg } }));
      if (pendingOnboard && onboardPayload) {
        dispatch(onboardTenant(onboardPayload));
      }
      setPendingOnboard(false);
      setOnboardPayload(null);
      dispatch(resetOnSuccess());
      dispatch(fetchProfile());
    } else {
      // Standalone behavior
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: serverMsg,
      });
      setIsChanged(false);
      // setHannaPwd('');
      dispatch(resetOnSuccess());
      dispatch(fetchProfile());
    }
  }, [updateSuccess, tenantUpdateState, flow.active, flow.wantOnboard, pendingOnboard, onboardPayload, dispatch]);




  // Password Update Error Messga
  useEffect(() => {
    if (errorMessagePass) {
      dispatch(resetOnSuccessChangePassword())
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setPasswordChange(false)
      Swal.fire({
        title: 'Error',
        text: errorMessagePass,
        icon: 'error',
        confirmButtonText: 'Retry',
        showCancelButton: true,
        customClass: {
          title: 'my-custom-title-of-pop-login',
          confirmButton: 'my-custom-button-of-pop',
        },
      });
    }
  }, [errorMessagePass]);
  // Password Update Success
  useEffect(() => {
    if (updateSuccessPass) {
      setOldPassword('');
      setNewPassword('');
      setConfirmPassword('');
      setPasswordChange(false)
      Swal.fire({
        icon: 'success',
        title: 'Success',
        text: 'Password updated successfully!',
      });
      dispatch(resetOnSuccessChangePassword())
    }
  }, [updateSuccessPass]);


  // Safe HTML escaping for any server text you show inside the custom Swal html
  const yadsEscapeHtml = (str = '') => String(str)
    .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;').replace(/'/g, '&#39;');

  // Inject once (same styles you used on the ingestion screen)
  // Inject/replace styles: stack cards vertically full-width
  // Inject/replace styles: compact, horizontal, full-width rows
  const ensureYadsSwalStyles = () => {
    const css = `
/* container */
.swal2-popup.yads-swal{padding:26px 26px 22px}
.yads-outcomeGrid{display:grid;grid-template-columns:1fr;gap:14px;margin-top:8px}

/* card - horizontal row */
.yads-card{
  border:1px solid #e5e7eb;border-radius:12px;background:#fff;
  box-shadow:0 1px 2px rgba(16,24,40,.05);width:100%;
  padding:14px 16px;
  text-align:left;                /* <-- force left */
}
.yads-cardRow{display:flex;align-items:flex-start;gap:14px}

/* icon */
.yads-left{flex:0 0 auto}
.yads-badge{
  width:40px;height:40px;border-radius:9999px;
  display:grid;place-items:center;font-weight:700;font-size:18px;
  box-shadow:inset 0 0 0 1px rgba(0,0,0,.04);
}
.yads-badge--success{background:#ecfdf5;color:#059669}
.yads-badge--warn{background:#fff7ed;color:#f97316}
.yads-badge--error{background:#fef2f2;color:#dc2626}

/* content */
.yads-right{
  flex:1 1 auto;
  display:flex;flex-direction:column;align-items:flex-start; /* <-- left */
}
.yads-titleLine{
  display:flex;align-items:center;gap:10px;flex-wrap:wrap;   /* keeps pill next to title */
}
.yads-card__title{margin:0;font-weight:600;color:#0f172a;font-size:18px;line-height:1.2}
.yads-chip{display:inline-block;font-size:12px;padding:4px 10px;border-radius:9999px}
.yads-chip--success{background:#e8faf0;color:#0f766e}
.yads-chip--warn{background:#fff1e6;color:#9a3412}
.yads-chip--error{background:#fde8e8;color:#b91c1c}
.yads-card__msg{
  margin:6px 0 0;color:#334155;line-height:1.45;font-size:16px;
  max-width:none;                                   /* no narrow column */
  text-align:left;                                  /* <-- left */
}

/* retry */
.yads-btn{
  margin:10px 0 0;
  display:inline-flex; align-items:center; gap:8px;   /* icon + label */
  border:1px solid #cbd5e1; border-radius:9999px;
  background:#fff; padding:8px 14px;
  font-size:14px; font-weight:600; color:#0f172a;
  cursor:pointer; transition:all .15s ease;
}
.yads-btn:hover{ background:#f8fafc; box-shadow:0 1px 2px rgba(16,24,40,.08); border-color:#94a3b8; }
.yads-btn:focus{ outline:none; box-shadow:0 0 0 3px rgba(5,38,78,.15); }
.yads-btn:active{ transform:translateY(1px); }
.yads-btn:disabled{ opacity:.6; cursor:default; }

.yads-btn__icon{ width:16px; height:16px; stroke:currentColor; }
`;
    let s = document.getElementById('yads-swal-styles');
    if (s) { s.textContent = css; return; }
    s = document.createElement('style');
    s.id = 'yads-swal-styles';
    s.textContent = css;
    document.head.appendChild(s);
  };





  useEffect(() => {
    if (!(flow.active && flow.wantOnboard)) return;

    const saveDone = ['success', 'error'].includes(flow.save.status);
    const onboardDone = ['success', 'error', 'skipped'].includes(flow.onboard.status);
    if (!saveDone || !onboardDone) return;

    ensureYadsSwalStyles();

    const chip = (s) => s === 'success' ? 'Succeeded' : s === 'error' ? 'Failed' : s === 'skipped' ? 'Skipped' : 'Not needed';
    const badgeCls = (s) => s === 'success' ? 'success' : s === 'error' ? 'error' : 'warn';
    const iconChar = (s) => s === 'success' ? '✓' : s === 'error' ? '✖' : '!';
    const chipCls = (s) => badgeCls(s);

    // Generic row
    const row = (label, status, msg) => `
  <div class="yads-card yads-cardRow">
    <div class="yads-left"><span class="yads-badge yads-badge--${badgeCls(status)}">${iconChar(status)}</span></div>
    <div class="yads-right">
      <div class="yads-titleLine">
        <span class="yads-card__title">${label}</span>
        <span class="yads-chip yads-chip--${chipCls(status)}">${chip(status)}</span>
      </div>
      <p class="yads-card__msg">${msg ? yadsEscapeHtml(msg) : '&nbsp;'}</p>
    </div>
  </div>
`;

    // Onboarding row with conditional Retry
    const rowOnboard = (status, msg, details = []) => `
  <div class="yads-card yads-cardRow">
    <div class="yads-left">
      <span class="yads-badge yads-badge--${badgeCls(status)}">${iconChar(status)}</span>
    </div>
    <div class="yads-right">
      <div class="yads-titleLine">
        <span class="yads-card__title">Onboarding</span>
        <span class="yads-chip yads-chip--${chipCls(status)}">${chip(status)}</span>
      </div>

      ${msg ? `<div class="yads-summary">${yadsEscapeHtml(msg)}</div>` : ''}

      ${details.length
        ? `
            <div class="yads-steps">
              ${details
          .map(
            (item) => `
                    <div class="yads-step">
                      <div class="yads-step__head">
                        <span class="yads-step__label">${yadsEscapeHtml(item.label)}</span>
                        <span class="yads-step__chip yads-step__chip--${item.tone || (status === 'error' ? 'warn' : 'success')}">
                          ${item.tone === 'error' ? 'Failed' : item.tone === 'warn' ? 'Check' : 'Done'}
                        </span>
                      </div>
                      <div class="yads-step__msg">${yadsEscapeHtml(item.msg)}</div>
                    </div>
                  `
          )
          .join('')}
            </div>
          `
        : ''
      }

      ${status === 'error'
        ? `<button id="yads-retry-onboard" class="yads-btn" type="button" aria-label="Retry onboarding">
             <svg viewBox="0 0 24 24" fill="none" class="yads-btn__icon" aria-hidden="true">
               <path d="M21 12a9 9 0 1 1-2.64-6.36M21 4v6h-6"
                     stroke="currentColor" stroke-width="2"
                     stroke-linecap="round" stroke-linejoin="round"/>
             </svg>
             Retry
           </button>`
        : ``}
    </div>
  </div>
`;

    const anyFail = (flow.save.status === 'error') || (flow.onboard.status === 'error');
    const bothFail = (flow.save.status === 'error') && (flow.onboard.status === 'error');

    const topKind = bothFail ? 'error' : anyFail ? 'warning' : 'success';
    const topTitle = bothFail ? 'Both requests failed' : anyFail ? 'Partial success' : 'All done';

    const html = `
    <div class="yads-outcomeGrid">
    ${row('Save Tenant Details', flow.save.status, flow.save.msg)}
     ${rowOnboard(
      flow.onboard.status === 'na' ? 'warn' : flow.onboard.status,
      flow.onboard.msg,
      flow.onboard.details || []
    )}
  </div>
  `;

    Swal.fire({
      icon: topKind,
      title: topTitle,
      html,
      customClass: { popup: 'yads-swal' },
      confirmButtonColor: '#05264e',
      didOpen: (el) => {
        const btn = el.querySelector('#yads-retry-onboard');
        if (!btn) return;

        btn.addEventListener('click', () => {
          btn.disabled = true;
          btn.textContent = 'Retrying…';

          // use the last payload; fall back to current form values if needed
          const retryPayload = lastOnboardPayloadRef.current || {
            bhomUrl: tenantData.bhomUrl,
            itsmUrl: tenantData.itsmUrl,
            key: tenantData.key,
            secretKey: tenantData.secretKey,
            // password: hannaPwd?.trim() ? hannaPwd.trim() : null,
            // password: hannaPwd?.trim() ? hannaPwd.trim() : null,
            username: (tenantData?.username || "").trim(),
            password: tenantData?.password || "",
            // adminPassword: hannaPwd?.trim() ? hannaPwd.trim() : null,
          };

          Swal.close(); // close current summary

          // spin up a new "only onboarding" flow
          setFlow({
            active: true,
            wantOnboard: true,
            // keep prior save status (already succeeded/failed)
            save: flow.save?.status ? flow.save : { status: 'success', msg: '' },
            onboard: { status: 'pending', msg: '' },
          });

          lastOnboardPayloadRef.current = retryPayload; // keep for another retry if needed
          dispatch(onboardTenant(retryPayload));
        });
      }
    }).then(() => {
      // (optional) clean-ups after close when not retrying
      setFlow(FLOW_IDLE);
      setOnboardOptIn(false);
      // setHannaPwd('');
    });
  }, [flow]);







  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width <= 768) {
        setScreenSize('mobile');
      } else if (width <= 1024) {
        setScreenSize('tablet');
      } else {
        setScreenSize('desktop');
      }
    };

    handleResize(); // Call on initial render
    window.addEventListener('resize', handleResize); // Add event listener for resize

    return () => {
      window.removeEventListener('resize', handleResize); // Cleanup on component unmount
    };
  }, []);




  useEffect(() => {
    if (profileState.profile) {
      setProfileData(profileState.profile);
    }
  }, [profileState.profile]);




  useEffect(() => {
    const toggles = document.querySelectorAll('.togCheck');
    toggles.forEach(toggle => {
      toggle.addEventListener('change', function () {
        if (this.checked) {
          toggles.forEach(otherToggle => {
            if (otherToggle !== this) {
              otherToggle.checked = false;
            }
          });
        }
      });
    });

    return () => {
      toggles.forEach(toggle => {
        toggle.removeEventListener('change', function () { });
      });
    };
  }, []);



  useEffect(() => {
    const first = tenantDetailsArr?.[0];
    if (!first) return;

    setTenantData({
      bhomUrl: first?.["BHOM URL"] || "",
      itsmUrl: first?.["ITSM REST API URL"] || "",
      key: first?.["Access Key"] || "",
      secretKey: first?.["Access Secret Key"] || "",
      username: first?.["ITSM Username"] || "",
      password: first?.["ITSM Password"] || "",
    });
  }, [tenantDetailsArr]);




  const downloadBadge = (badgde) => {
    const link = document.createElement('a');
    link.href = badgde;
    window.open(badgde, '_blank');
  };

  const shareOnLinkedIn = (badgde) => {
    const badgeUrl = encodeURIComponent(badgde);
    const linkedInUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${badgeUrl}`;
    window.open(linkedInUrl, '_blank');
  };









  const trackDetails = profileDetails?.['microcerts-progress'];
  const completedMicrocerts = profileDetails?.['completed-microcerts'];
  const handleNextStep = () => {
    if (step === 1 && oldPassword.trim() === '') {
      // If step is 1 and old password not entered, do not proceed
      alert('Please enter old password.');
      return;
    }
    setStep(step + 1);
  };


  const handleOldPasswordChange = (event) => {
    setOldPassword(event.target.value);
  };

  const handleNewPasswordChange = (event) => {
    setNewPassword(event.target.value);
  };

  const handleConfirmPasswordChange = (event) => {
    setConfirmPassword(event.target.value);
  };




  const updatePassowrd = (e) => {

    e.preventDefault();
    dispatch(changePassword(oldPassword, newPassword, confirmPassword));
  }







  const renderPasswordInputs = () => {
    switch (step) {
      case 1:
        return (
          <>
            <input
              name='old-password'
              type="password"
              className='input-box-transfer'
              placeholder="Old Password"
              value={oldPassword}
              onChange={handleOldPasswordChange}
            />
            <br />
            <br />
            <div className='just-con-password'>
              <button onClick={handleNextStep} className='change-passwrod-btn'>Next</button>
              <p onClick={() => handleClosePay()} className='pay-box-pa'>Cancel</p>
            </div>
          </>
        );
      case 2:
        return (
          <>
            <input
              name='new-passowrd'
              type="password"
              className='input-box-transfer'
              placeholder="New Password"
              value={newPassword}
              onChange={handleNewPasswordChange}
            />
            <br />
            <input
              name='con-passowrd'
              type="password"
              className='input-box-transfer'
              placeholder="Confirm New Password"
              value={confirmPassword}
              onChange={handleConfirmPasswordChange}
            />
            <br />
            <br />
            <div className='just-con-password'>
              <button className='change-passwrod-btn' onClick={updatePassowrd}>Update Password</button>
              <p onClick={() => handleClosePay()} className='pay-box-pa'>Cancel</p>
            </div>

          </>
        );
      default:
        return null;
    }
  };









  const countMicrocertStatus = (microcerts) => {
    let completed = 0;
    let pending = 0;
    microcerts.forEach(microcert => {
      if (completedTracks[microcert.trackId] && completedTracks[microcert.trackId][microcert.id]) {
        completed++;
      } else {
        pending++;
      }
    });
    return { completed, pending };
  };


  const getMicrocertStatus = (microcert) => {
    if (!microcert.videoStatus && !microcert.questionStatus) {
      return "Not Completed";
    } else if (microcert.videoStatus && !microcert.questionStatus) {
      return "In Progress";
    } else if (microcert.videoStatus && microcert.questionStatus) {
      return "Completed";
    }
  };


  // Adding Multiple Tenant
  // ================================
  // Dummy Multiple Tenants UI (NO API)
  // Scroll only list, show full form outside scroll
  // ================================

  // ================================
  // Dummy Multiple Tenants UI (NO API)
  // UX:
  // - default: show 3 rows, no scroll
  // - "Show all": list becomes scrollable
  // - selecting any tenant shows FULL form (not scrollable)
  // ================================

  const normalizeTenantDetails = (tenantDetails = []) => {
    if (!Array.isArray(tenantDetails)) return [];

    return tenantDetails.map((t, idx) => {
      const bhomUrl = t?.["BHOM URL"] || "";            // coming from profile API
      const itsmUrl = t?.["ITSM REST API URL"] || "";
      const key = t?.["Access Key"] || "";
      const secretKey = t?.["Access Secret Key"] || "";
      const username = t?.["ITSM Username"] || "";
      const password = t?.["ITSM Password"] || "";
      const type = t?.["type"] || "user";

      const tenantUrl = bhomUrl; // ✅ unify UI field name

      const id = tenantUrl ? `tenant:${tenantUrl}` : `idx:${idx}`;

      return {
        id,
        name: `Tenant ${idx + 1}`,
        url: tenantUrl,           // list display/search
        tenantUrl,                // ✅ use this everywhere in panel
        originalTenantUrl: tenantUrl,
        bhomUrl: tenantUrl,       // optional alias if you still need it elsewhere
        itsmUrl,
        key,
        secretKey,
        username,
        password,
        type,
        onboard: false,
        // onboardPwd: "",
        active: true,
      };
    });
  };


  const apiTenants = React.useMemo(() => {
    return normalizeTenantDetails(tenantDetailsArr);
  }, [tenantDetailsArr]);



  const MultiTenantPanel = ({ apiTenants = [], deleteTenantState = {} }) => {
    const dispatch = useDispatch();

    const deleteLoading = !!deleteTenantState.loading;
    const deleteError = deleteTenantState.error;
    const deleteSuccess = deleteTenantState.success;


    const [tenants, setTenants] = useState([]);
    const [query, setQuery] = useState("");
    // const [showAll, setShowAll] = useState(false);

    useEffect(() => {
      if (!deleteError) return;

      Swal.fire({
        icon: 'error',
        title: 'Delete failed',
        text: deleteError,
        confirmButtonColor: '#05264e',
      });

      dispatch(deleteUserTenantReset());
    }, [deleteError, dispatch]);

    useEffect(() => {
      if (!deleteSuccess) return;

      Swal.fire({
        icon: 'success',
        title: 'Deleted',
        text: 'Tenant removed successfully.',
        confirmButtonColor: '#05264e',
      });

      dispatch(deleteUserTenantReset());
    }, [deleteSuccess, dispatch]);


    const [pendingOpenId, setPendingOpenId] = useState(null);

    useEffect(() => {
      if (!pendingOpenId) return;
      const exists = tenants.some(t => t.id === pendingOpenId);
      if (exists) {
        setOpenId(pendingOpenId);
        setPendingOpenId(null);
      }

    }, [tenants, pendingOpenId]);

    useEffect(() => {
      setTenants(apiTenants || []);
    }, [apiTenants]);

    // ✅ only one open at a time
    const [openId, setOpenId] = useState(null);

    // ✅ Add Tenant Modal
    const [showAddModal, setShowAddModal] = useState(false);
    const [addForm, setAddForm] = useState({
      tenantUrl: "",
      itsmUrl: "",
      key: "",
      secretKey: "",
      username: "",
      password: "",        // ITSM Password (existing)
      onboard: false,
      // onboardPwd: "",      // ✅ Hanna password for onboarding (new)
    });


    const activeCount = tenants.filter((t) => t.active).length;

    const filtered = React.useMemo(() => {
      const q = query.trim().toLowerCase();
      if (!q) return tenants;
      return tenants.filter((t) => (t.url || "").toLowerCase().includes(q));
    }, [query, tenants]);

    // close accordion if filtered out
    useEffect(() => {
      if (!openId) return;
      const exists = filtered.some((t) => t.id === openId);
      if (!exists) setOpenId(null);
    }, [filtered, openId]);

    // const visibleRows = React.useMemo(() => {
    //   return showAll ? filtered : filtered.slice(0, 3);
    // }, [filtered, showAll]);

    // const hiddenCount = Math.max(filtered.length - 3, 0);

    // ✅ scroll mode logic
    // const listMode = openId ? "expanded" : showAll ? "scroll" : "collapsed";

    const visibleRows = filtered;

    // ✅ default: scroll mode, unless expanded
    const listMode = openId ? "expanded" : "scroll";


    const onFieldChange = (id, field, value) => {
      setTenants((prev) =>
        prev.map((t) => (t.id === id ? { ...t, [field]: value } : t))
      );
    };



    const onToggleOnboard = (id) => {
      setTenants((prev) =>
        prev.map((t) => {
          if (t.id !== id) return t;
          const next = !t.onboard;
          return { ...t, onboard: next, onboardPwd: next ? t.onboardPwd : "" };
        })
      );
    };


    const toggleTenant = (id) => {
      setOpenId((prev) => (prev === id ? null : id));

      // keep clicked item in view (no jump to first)
      requestAnimationFrame(() => {
        const el = document.getElementById(`tenant-item-${id}`);
        if (el) el.scrollIntoView({ block: "nearest", behavior: "smooth" });
      });
    };

    const updateTenant = (t) => {
      const payload = {
        tenantUrl: (t.tenantUrl || "").trim(),
        itsmUrl: (t.itsmUrl || "").trim(),
        key: (t.key || "").trim(),
        secretKey: (t.secretKey || "").trim(),
        username: (t.username || "").trim(),
        password: t.password || "",
      };

      if (!payload.tenantUrl || !payload.key || !payload.secretKey) {
        Swal.fire({
          icon: "warning",
          title: "Missing details",
          text: "Please fill BHOM URL, Access Key and Access Secret Key.",
          confirmButtonColor: "#05264e",
        });
        return;
      }

      const wantOnboard = !!t.onboard;

      if (wantOnboard) {
        setFlow({
          active: true,
          wantOnboard: true,
          save: { status: "pending", msg: "" },
          onboard: { status: "pending", msg: "" },
        });

        const obPayload = {
          bhomUrl: payload.tenantUrl, // ✅ onboard API expects bhomUrl
          itsmUrl: payload.itsmUrl || null,
          key: payload.key,
          secretKey: payload.secretKey,
          // password: (t.onboardPwd || "").trim() ? (t.onboardPwd || "").trim() : null, // ✅ inline optional
          // ✅ NEW
          username: (payload.username || "").trim(),
          password: payload.password || "",

          // ✅ optional
          // adminPassword: (t.onboardPwd || "").trim() ? (t.onboardPwd || "").trim() : null,
        };

        setPendingOnboard(true);
        setOnboardPayload(obPayload);
        lastOnboardPayloadRef.current = obPayload;

        dispatch(updateTenantDetails(payload)); // ✅ save first; onboarding triggers after updateSuccess
        return;
      }

      // no onboarding requested
      setFlow(FLOW_IDLE);
      setPendingOnboard(false);
      setOnboardPayload(null);
      dispatch(updateTenantDetails(payload));
    };


    const onOnboardPwdChange = (id, value) => {
      setTenants((prev) =>
        prev.map((t) => (t.id === id ? { ...t, onboardPwd: value } : t))
      );
    };


    const deleteTenant = (tenantUrl, id) => {
      Swal.fire({
        icon: "warning",
        title: "Remove Tenant?",
        text: "This will remove this tenant from your list across all views.",
        showCancelButton: true,
        confirmButtonText: "Delete",
        cancelButtonText: "Cancel",
        confirmButtonColor: "#111827",
      }).then((res) => {
        if (!res.isConfirmed) return;

        // optional: optimistic UI
        setTenants((prev) => prev.filter((t) => t.id !== id));
        if (openId === id) setOpenId(null);

        // ✅ real API call
        dispatch(deleteUserTenant(tenantUrl));
      });
    };


    // -------------------------
    // ✅ Add Tenant Modal logic
    // -------------------------
    const openAddModal = () => {
      setAddForm({
        tenantUrl: "",
        itsmUrl: "",
        key: "",
        secretKey: "",
        username: "",
        password: "",
        onboard: false,
        // onboardPwd: "",
      });
      setShowAddModal(true);
    };

    const closeAddModal = () => setShowAddModal(false);

    const onAddFormChange = (field, value) => {
      setAddForm((p) => ({ ...p, [field]: value }));
    };

    const submitAddTenant = () => {
      const tenantUrl = addForm.tenantUrl.trim();
      const itsmUrl = addForm.itsmUrl.trim();
      const key = addForm.key.trim();
      const secretKey = addForm.secretKey.trim();

      if (!tenantUrl || !key || !secretKey) {
        Swal.fire({
          icon: "warning",
          title: "Missing details",
          text: "Please fill BHOM URL, Access Key and Access Secret Key.",
          confirmButtonColor: "#05264e",
        });
        return;
      }

      // ✅ If you want, prevent duplicate BHOM URL in UI
      const duplicate = (tenants || []).some(t =>
        ((t.tenantUrl || t.bhomUrl || t.url || "").trim()) === tenantUrl
      );
      if (duplicate) {
        Swal.fire({
          icon: "warning",
          title: "Already exists",
          text: "This BHOM URL already exists in your tenants.",
          confirmButtonColor: "#05264e",
        });
        return;
      }

      // ✅ Build "save to DB" payload (your backend fields)
      const savePayload = {
        tenantUrl,
        itsmUrl: itsmUrl || "",
        key,
        secretKey,
        username: addForm.username.trim(),
        password: addForm.password, // ITSM password (if your backend stores it)
      };

      // ✅ Use same coordinated popup flow logic as your existing screen:
      // 1) mark flow pending
      // 2) dispatch PATCH addTenantDetails
      // 3) after success effect, dispatch onboardTenant if opted-in

      const wantOnboard = !!addForm.onboard;

      if (wantOnboard) {
        setFlow({
          active: true,
          wantOnboard: true,
          save: { status: "pending", msg: "" },
          onboard: { status: "pending", msg: "" }, // real onboard starts after save success
        });

        // chain onboarding after save success (your existing mechanism)
        const obPayload = {
          bhomUrl: tenantUrl,                 // ✅ IMPORTANT: onboard expects bhomUrl
          itsmUrl: itsmUrl || null,
          key,
          secretKey,
          // password: addForm.onboardPwd?.trim() ? addForm.onboardPwd.trim() : null,
          // ✅ NEW (from add form)
          username: (addForm.username || "").trim(),
          password: addForm.password || "",

          // ✅ optional
          // adminPassword: addForm.onboardPwd?.trim() ? addForm.onboardPwd.trim() : null,
        };


        setPendingOnboard(true);
        setOnboardPayload(obPayload);
        lastOnboardPayloadRef.current = obPayload;
      } else {
        setFlow(FLOW_IDLE);
        setPendingOnboard(false);
        setOnboardPayload(null);
      }

      // Close modal immediately, show loader overlay + avoid double submit
      setShowAddModal(false);

      // After profile refresh, open the new tenant
      setPendingOpenId(`tenant:${tenantUrl}`);


      // ✅ PATCH save to DB
      dispatch(addTenantDetails(savePayload));
    };


    // icons
    const SearchIcon = () => (
      <svg viewBox="0 0 24 24" className="mt-icon" aria-hidden="true">
        <path
          d="M10.5 18a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15Zm6.2-1.3 4.1 4.1"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

    const Chevron = ({ open }) => (
      <svg
        viewBox="0 0 24 24"
        className={`mt-icon mt-chevron ${open ? "is-open" : ""}`}
        aria-hidden="true"
      >
        <path
          d="M6 9l6 6 6-6"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );

    const Plus = () => (
      <svg viewBox="0 0 24 24" className="mt-plus" aria-hidden="true">
        <path
          d="M12 5v14M5 12h14"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
      </svg>
    );

    return (
      <div className="mt-wrap">
        <div className="mt-subhead">
          <h1 className="acc-info-top-head-h1">Your Tenants</h1>
          <div className="mt-subhead-right">{activeCount} active</div>
        </div>

        <div className="mt-search">
          <input
            className="mt-search-input"
            placeholder="Search by URL"
            value={query}
            onChange={(e) => setQuery(e.target.value)}
          />
          <div className="mt-search-icon">
            <SearchIcon />
          </div>
        </div>

        <div className={`mt-list-shell mt-mode-${listMode}`}>
          <div className="mt-list">
            {visibleRows.map((t) => {
              const isOpen = openId === t.id;

              return (
                <div key={t.id} id={`tenant-item-${t.id}`} className="mt-item">
                  <button
                    type="button"
                    className={`mt-row mt-row--selectable ${isOpen ? "is-selected" : ""}`}
                    onClick={() => toggleTenant(t.id)}
                  >
                    <div className="mt-url">
                      <div className="mt-tenant-name">{t.name}</div>
                      <div className="mt-tenant-url">{t.url}</div>
                    </div>
                    <div className="mt-row-right">
                      <Chevron open={isOpen} />
                    </div>
                  </button>

                  {isOpen && (
                    <div className="mt-expand">
                      <div className="mt-kv">
                        <div className="mt-k">BHOM URL</div>

                        <TenantUrlInput
                          className="mt-v"
                          value={t.tenantUrl || ""}
                          template={BHOM_TEMPLATE}
                          onChange={(value) => onFieldChange(t.id, "tenantUrl", value)}
                        />
                      </div>


                      <div className="mt-kv">
                        <div className="mt-k">ITSM REST API URL</div>

                        <TenantUrlInput
                          className="mt-v"
                          value={t.itsmUrl || ""}
                          template={ITSM_TEMPLATE}
                          onChange={(value) => onFieldChange(t.id, "itsmUrl", value)}
                        />
                      </div>


                      <div className="mt-kv">
                        <div className="mt-k">Access Key</div>
                        <input
                          className="mt-v"
                          value={t.key}
                          onChange={(e) => onFieldChange(t.id, "key", e.target.value)}
                        />
                      </div>

                      <div className="mt-kv">
                        <div className="mt-k">Access Secret Key</div>
                        <input
                          className="mt-v"
                          value={t.secretKey}
                          onChange={(e) => onFieldChange(t.id, "secretKey", e.target.value)}
                        />
                      </div>

                      <div className="mt-kv">
                        <div className="mt-k">ITSM Username</div>
                        <input
                          className="mt-v"
                          value={t.username}
                          onChange={(e) => onFieldChange(t.id, "username", e.target.value)}
                        />
                      </div>

                      <div className="mt-kv">
                        <div className="mt-k">ITSM Password</div>
                        <input
                          className="mt-v"
                          value={t.password}
                          onChange={(e) => onFieldChange(t.id, "password", e.target.value)}
                        />
                      </div>

                      {/* <label className="mt-optin">
                        <input
                          type="checkbox"
                          checked={!!t.onboard}
                          onChange={() => onToggleOnboard(t.id)}
                        />
                        <span>
                          Onboard to Tech Central to ingest logs and metrics for demo catalog
                          narratives
                        </span>
                      </label> */}

                      {/* {t.onboard && (
                        <>
                          <div id="oi-hannaPwd-help" className="oi-callout oi-callout--warn" role="note">
                            <span className="oi-callout__icon" aria-hidden="true">⚠️</span>
                            <span>
                              <strong>Required if you were given a password.</strong> If you weren’t provided one,
                              leave this field blank and the system will use the default onboarding password.
                            </span>
                          </div>
                          <div className="mt-kv">
                            <div className="mt-k">hannah_admin Password</div>
                            <input
                              type="password"
                              className="mt-v"
                              value={t.onboardPwd || ""}
                              onChange={(e) => onOnboardPwdChange(t.id, e.target.value)}
                            />
                          </div>
                        </>
                      )} */}


                      <div className="mt-actions">
                        <button
                          type="button"
                          className="mt-btn-primary"
                          onClick={() => updateTenant(t)}
                        >
                          Update Details
                        </button>



                        <button
                          type="button"
                          className="mt-btn-danger"
                          onClick={() => deleteTenant(t.tenantUrl, t.id)}
                          disabled={deleteLoading}
                        >
                          {deleteLoading ? 'Deleting…' : 'Remove Tenant'}
                        </button>

                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        {/* {filtered.length > 3 && (
          <button
            type="button"
            className="mt-showall"
            onClick={() => {
              setShowAll((p) => {
                const next = !p;
                if (!next) setOpenId(null);
                return next;
              });
            }}
          >
            {showAll ? "Show less" : `Show all tenants (${hiddenCount} more)`}
          </button>
        )} */}

        {/* ✅ Add new tenant button -> opens modal (NOT direct add) */}
        <button type="button" className="mt-add" onClick={openAddModal}>
          <Plus />
          <div className="mt-add-text">Add new tenant</div>
        </button>

        {/* ✅ Add Tenant Modal (matches screenshot) */}
        <Modal
          show={showAddModal}
          onHide={closeAddModal}
          centered
          backdrop="static"
          keyboard={false}
          dialogClassName="mt-addTenant-modal"
        >
          <Modal.Body className="mt-addTenant-body">
            <div className="mt-addTenant-header">Add Tenant</div>

            <div className="mt-addTenant-form">
              <label className="mt-addTenant-label">BHOM URL</label>
              <TenantUrlInput
                className="mt-addTenant-input"
                value={addForm.tenantUrl || ""}
                template={BHOM_TEMPLATE}
                onChange={(value) => onAddFormChange("tenantUrl", value)}
              />


              <label className="mt-addTenant-label">ITSM REST API URL</label>
              <TenantUrlInput
                className="mt-addTenant-input"
                value={addForm.itsmUrl || ""}
                template={ITSM_TEMPLATE}
                onChange={(value) => onAddFormChange("itsmUrl", value)}
              />


              {/* ---- Row 1: Access Key + Secret Key ---- */}
              <div className="mt-addTenant-grid2">
                <div className="mt-addTenant-field">
                  <label className="mt-addTenant-label">Access Key</label>
                  <input
                    className="mt-addTenant-input"
                    value={addForm.key}
                    onChange={(e) => onAddFormChange("key", e.target.value)}
                  />
                </div>

                <div className="mt-addTenant-field">
                  <label className="mt-addTenant-label">Access Secret Key</label>
                  <input
                    className="mt-addTenant-input"
                    value={addForm.secretKey}
                    onChange={(e) => onAddFormChange("secretKey", e.target.value)}
                  />
                </div>
              </div>

              {/* ---- Row 2: Username + Password ---- */}
              <div className="mt-addTenant-grid2">
                <div className="mt-addTenant-field">
                  <label className="mt-addTenant-label">ITSM Username</label>
                  <input
                    className="mt-addTenant-input"
                    value={addForm.username}
                    onChange={(e) => onAddFormChange("username", e.target.value)}
                  />
                </div>

                <div className="mt-addTenant-field">
                  <label className="mt-addTenant-label">ITSM Password</label>
                  <input
                    type="password"
                    className="mt-addTenant-input"
                    value={addForm.password}
                    onChange={(e) => onAddFormChange("password", e.target.value)}
                  />
                </div>
              </div>

              {/* <label className="mt-addTenant-checkRow">
                <input
                  type="checkbox"
                  checked={!!addForm.onboard}
                  onChange={() => onAddFormChange("onboard", !addForm.onboard)}
                />
                <span>
                  Onboard to Tech Central to ingest logs and metrics for demo catalog narratives
                </span>
              </label> */}
              {/* {addForm.onboard && (
                <>
                 
                  <div id="oi-hannaPwd-help" className="oi-callout oi-callout--warn" role="note">
                    <span className="oi-callout__icon" aria-hidden="true">⚠️</span>
                    <span>
                      <strong>Required if you were given a password.</strong> If you weren’t provided one,
                      leave this field blank and the system will use the default onboarding password.
                    </span>
                  </div>
                  <label className="mt-addTenant-label">hannah_admin Password</label>
                  <input
                    type="password"
                    className="mt-addTenant-input"
                    value={addForm.onboardPwd}
                    onChange={(e) => onAddFormChange("onboardPwd", e.target.value)}
                  />
                </>
              )} */}

            </div>

            <div className="mt-addTenant-actions">
              <button type="button" className="mt-addTenant-primary" onClick={submitAddTenant}>
                Add Tenant
              </button>
              <button type="button" className="mt-addTenant-cancel" onClick={closeAddModal}>
                Cancel
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  };


  return (
    <>
      {isLoading && <LoadingScreen />}
      {isLoadingPass && <LoadingScreen text="Wait for Password Update" />}
      {isLoadingPro && <LoadingScreen text="Getting You Profile" />}
      {onboardState?.loading && <LoadingScreen />}



      <Navbar activeTab={"USER_PROFILE"} />


      <div id='user-profile-background'>
        <div className='container' >
          <br></br>

          {/* User Details */}
          <div class="row">
            <div class="col-md-5">
              <div className='user-profile-details-card'>

                {/* Account Information */}

                <div className='acc-info-top-head'>
                  <h1 className='acc-info-top-head-h1'>Account Information</h1>
                  {/* <p className='acc-info-top-head-p' onClick={handleShowPay}>Edit</p> */}
                </div>


                <br></br>

                {/* Email */}
                <div className='acc-info-sec'>
                  <p className='acc-info-sec-p'>Email</p>
                  <p className='acc-info-sec-p2'>{profileDetails ? profileDetails.email : 'Loading'}</p>
                </div>
                <hr className='hr-line-one'></hr>

               

                <br></br>






                {/* Password */}
                <div className='acc-info-sec'>
                  <p className='acc-info-sec-p'>Password</p>
                  <p className='acc-info-sec-p2'>******</p>
                </div>
                <hr className='hr-line-one'></hr>





                {/* Change Details */}
                <center><button className='chnage-password' onClick={handleShowPay}>Change Password</button></center>

              </div>
            </div>

            {currentUser?.typeOfUser !== "Sales" && (
              <div class="col-md-7">
                <div className='user-profile-details-card-sales'>
                  <MultiTenantPanel apiTenants={apiTenants} deleteTenantState={deleteTenantState} />
                </div>
              </div>
            )}
          </div>




          {enableEnablement && (
          <>
          {/* Learning Hub Status */}
          <img src='https://res.cloudinary.com/dueblmbcc/image/upload/v1715861763/DC/Group_21954_bhuhq2.png' class="img-width-pro" />
          <br></br>
          <br></br>


          {trackDetails ? trackDetails.map((track, index) => (
            <div key={index}>
              <label for={track?.title} class="togButton-user-profile">
                <div class="course-card-profile">
                  <div class="course-details">
                    <div className='result-sec-flex'>
                      <div>
                        <h1 className='training-title'>{track?.title}</h1>
                        <div class="line-lear"></div>
                       <p>{track?.completionCount}</p>
                      </div>
                      <div>
                        <Link to={`${PATH.LEARNING_HUB_TRACKS_PATH}${track?.title}`} style={{ textDecoration: 'none' }}>
                          <h6 className='see-more-userprofile'>See More</h6>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </label>
              <input type="checkbox" class="togCheck" id={track.title} />
              <div class="togContent-profile">
                <div className="row">
                  {track.microcertsList.map((microcert) => (
                    <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4" key={microcert.certId}>
                      <div
                        className={`sub-course-card ${getMicrocertStatus(microcert) === 'Completed' ? 'completed' : getMicrocertStatus(microcert) === 'In Progress' ? 'in-progress' : 'not-completed'}`}
                      >
                        <div className="course-image-micro">
                          <img src={microcert.certThumnail} alt="Course Showcase Image" />
                        </div>
                        <div className="sub-course-details">
                          <h2 className='sub-course-name'>{microcert.title}</h2>
                          <div className="cour-dist">
                            <p className="sub-course-dist-det">
                              <span className="sub-course-dist-det-one">
                                &#8226; {getMicrocertStatus(microcert) === 'Completed' ? (
                                  <span className="completed-status">Completed</span>
                                ) : getMicrocertStatus(microcert) === 'In Progress' ? (
                                  <span className="in-progress-status">In Progress</span>
                                ) : (
                                  <span className="not-completed-status">Not Completed</span>
                                )}
                              </span>
                            </p>
                          </div>
                          <p className="sub-course-det-paragraph">{microcert.shortDescription}</p>
                          {getMicrocertStatus(microcert) === 'Completed' ? (
                            <>
                              <button className="badge-button" onClick={() => handleViewBadge(microcert?.completionBadge)}>
                                View Badge
                              </button>
                              <Link to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${track.title}/${encryptId(microcert.certId)}`}>
                                <p className="micr-certs-view-course-btn">View Course</p>
                              </Link>
                            </>
                          ) : (
                            <Link to={`${PATH.LEARNING_HUB_MICROCERTS_PATH}${track.title}/${encryptId(microcert.certId)}`}>
                              <p className="launch-button">Launch now {'>>'}</p>
                            </Link>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )) : <p>No microcerts data available.</p>}
          <br></br>
          <br></br>
          </>
          )}
        </div>
      </div>





      <Modal show={passwordChange} fullscreen={false} onHide={handleClosePay}>
        <Modal.Body className='modalght'>
          <div className="container px-4">
            <center>
              <div className='form-transfer'>
                <h6 className='form-heading'>Update Password</h6>
                <div>
                  {renderPasswordInputs()}
                </div>
              </div>
            </center>
          </div>
        </Modal.Body>
      </Modal>



      <Modal
        {...props}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        show={badgeModel}
        onHide={() => handleCloseViewBadge()}
        fullscreen={false}
      >
        <Modal.Body className='badgde-body'>
          <img className='badgde-cert' src={badgde} />
          <div className='badgde-btn'>
            <button className='download-badgde' onClick={() => downloadBadge(badgde)}>Download Badge</button>
            <button className='share-linkdin' onClick={() => shareOnLinkedIn(badgde)}>Share On LinkedIn</button>
          </div>
        </Modal.Body>
      </Modal>




    </>
  )
}

export default User_Profile
